package co.maytes.standupbot.dashboard.features.standupruns

import co.maytes.standupbot.shared.dto.standuprun.AtRiskItemDto
import co.maytes.standupbot.shared.dto.standuprun.StandupRunWarningDto
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

object AtRiskRules {
    const val INCOMPLETE_CODE = "at-risk-incomplete"
    const val STALE = "STALE_IN_PROGRESS"
    const val AWAITING_REVIEW = "AWAITING_REVIEW"
    const val BLOCKED = "BLOCKED"

    fun title(items: List<AtRiskItemDto>): String = "At risk (${items.count { it.listedInPost }} in the post, ${items.size} found)"

    fun reasonLabel(reason: String): String =
        when (reason) {
            STALE -> "Stale"
            AWAITING_REVIEW -> "Awaiting review"
            BLOCKED -> "Blocked"
            else -> reason
        }

    fun idleLabel(item: AtRiskItemDto): String =
        when (item.reason) {
            STALE -> "no movement for ${days(item.idleBusinessDays)}"
            AWAITING_REVIEW -> "waiting on review ${days(item.idleBusinessDays)}"
            BLOCKED -> "marked blocked"
            else -> days(item.idleBusinessDays)
        }

    fun reviewersLabel(item: AtRiskItemDto): String? =
        item.reviewerLogins.takeIf { it.isNotEmpty() }?.joinToString(", ", prefix = "Reviewers: ") { "@$it" }

    fun flaggedLabel(
        item: AtRiskItemDto,
        zone: TimeZone,
    ): String? =
        if (item.listedInPost) {
            null
        } else {
            item.flaggedBefore?.let { "Flagged ${shortDate(it, zone)}, not repeated" } ?: "Flagged before, not repeated"
        }

    fun incompleteMessage(warnings: List<StandupRunWarningDto>): String? = warnings.firstOrNull { it.code == INCOMPLETE_CODE }?.message

    fun shortDate(
        at: Instant,
        zone: TimeZone,
    ): String {
        val date = at.toLocalDateTime(zone).date
        return "${capitalised(date.dayOfWeek.name).take(SHORT)} ${date.dayOfMonth} ${capitalised(date.month.name).take(SHORT)}"
    }

    private fun capitalised(name: String): String = name.lowercase().replaceFirstChar { it.uppercase() }

    private fun days(count: Int): String = if (count == 1) "1 working day" else "$count working days"

    private const val SHORT = 3
}
